// Google Analytics 4 tracking helper for Metodo BDF Assessment
// Measurement ID configured in /public/index.html

const isBrowser = typeof window !== "undefined";

export const track = (eventName, params = {}) => {
  if (!isBrowser || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", eventName, params);
  } catch (e) {
    // silent
  }
};

export const trackBeacon = (eventName, params = {}) => {
  // Same as track() but forces beacon transport so events survive page unload.
  if (!isBrowser || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", eventName, { ...params, transport_type: "beacon" });
  } catch (e) {
    // silent
  }
};

// ============ Event helpers ============

// 1. Landing / home page view (auto via gtag config send_page_view=true).
// Custom event for explicit tracking of Assessment landing engagement.
export const trackLandingView = () => track("landing_page_view", { page: "home" });

// 2. Click "Inizia il tuo Assessment" on landing
export const trackStartCtaClick = () =>
  track("assessment_start_cta_click", { location: "home", cta: "inizia_assessment" });

// 3. Assessment started (after user info form submitted)
export const trackAssessmentStarted = ({ ruolo, stile_danza }) =>
  track("assessment_started", { ruolo, stile_danza });

// 4. Question advance (one per answered question)
export const trackQuestionAdvance = ({ question_number, question_id, area, ruolo, value }) =>
  track("question_advance", {
    question_number,
    question_id,
    area,
    ruolo,
    value,
  });

// 5. Assessment abandoned — fires on page unload if not completed
export const trackAssessmentAbandoned = ({ last_question_number, last_question_id, ruolo }) =>
  trackBeacon("assessment_abandoned", {
    last_question_number,
    last_question_id,
    ruolo,
  });

// 6. Assessment completed
export const trackAssessmentCompleted = ({ profilo, ruolo, total_questions, totale }) =>
  track("assessment_completed", {
    profilo,
    ruolo,
    total_questions,
    totale,
  });

// 7. Final CTA clicks (course / coaching / call)
export const trackCtaClick = ({ cta, url, profilo, ruolo }) =>
  track("cta_click", {
    cta,          // "course" | "coaching" | "call"
    cta_url: url,
    profilo,
    ruolo,
    location: "results",
  });
